import { useState } from "react";

import { Button, Stack } from "@mui/material";

import useFirebaseContext from "@/hooks/useFirebaseAuth";
import { UserRole } from "@/types";

interface Props {
  onProceed: () => void;
  onCancel: () => void;
  onEndLesson: () => void;
  lessonInfo: any;
  isSandbox?: boolean;
}

const ActionButtons = ({
  onProceed,
  onCancel,
  onEndLesson,
  lessonInfo,
  isSandbox = false,
}: Props) => {
  const [loading, setLoading] = useState(false);
  const { userRole } = useFirebaseContext();

  if (userRole !== UserRole.Student) return null;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {!lessonInfo.hasStarted ? (
        <>
          <Button
            variant="outlined"
            color="error"
            size="small"
            disableElevation
            disabled={loading}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="small"
            disableElevation
            disabled={loading}
            loading={loading}
            onClick={() => {
              setLoading(true);
              onProceed();
            }}
          >
            Proceed
          </Button>

        </>
      ) : (
        !isSandbox && (
          <Button
            variant="outlined"
            color="error"
            size="small"
            disableElevation
            onClick={onEndLesson}
          >
            End Lesson
          </Button>
        )
      )}
    </Stack>
  );
};

export default ActionButtons;
